<script>
    import { getPincodeData } from '@/services/campaignService';
    import UploadCsv from '../UploadCsv.vue';

    export default {
        name: 'PincodeSelection',
        components: {
            UploadCsv,
        },
        props: {
            pincodeFilter: String,
            pincodes: Array,
            pincodesExcept: Array
        },
        data() {
            return {
                selectionType: this.pincodeFilter,
                selections: [
                    {
                        type: 'ALL',
                        label: 'Select all Pincodes in India'
                    },
                    {
                        type: 'CUSTOM',
                        label: 'Enter Custom Pincode',
                    },
                    {
                        type: 'EXCEPT',
                        label: 'All Pincodes except'
                    },
                ],
                showUploadComponent: false,
                pincodeList: this.pincodeFilter === 'CUSTOM' ? this.pincodes : this.pincodesExcept,
                pincodeInput: '',
                showSuggestion: false,
                suggestion: {}
            }
        },
        methods: {
            onListClick() {
                this.showUploadComponent = false;
            },
            onUploadClick() {
                this.showUploadComponent = true;
            },
            onSuggestionClick() {
                if(Object.keys(this.suggestion).length) {
                    this.pincodeList = [{...this.suggestion}, ...this.pincodeList]
                    this.showSuggestion = false;
                    this.pincodeInput = '';
                    this.suggestion = {};
                    this.$emit('pincodeData', this.pincodeFilter, this.pincodeList);
                }
            },
            onRemoveClick(selectedPincode) {
                this.pincodeList = this.pincodeList.filter(item => item.pincode !== selectedPincode.pincode);
                this.$emit('pincodeData', this.pincodeFilter, this.pincodeList);
            },
            cleanVariable(event) {
                this.pincodeInput = event.target.value.replace(/[^0-9]/g, "");
            },
            getPincodeList(data) {
                this.showUploadComponent = false;
                const filteredData = data.filter((item) => !this.pincodeList.map(pincode => pincode.pincode).includes(item.pincode))
                this.pincodeList = [...filteredData, ...this.pincodeList];
                this.$emit('pincodeData', this.pincodeFilter, this.pincodeList);
            }
        },
        watch: {
            pincodeInput: function(value) {
                if(value.length == 6) {
                    const exists = this.pincodeList.some((item) => item.pincode == value);
                    if(!exists) {
                        getPincodeData(value)
                        .then((res) => res.json())
                        .then((data) => {
                            if(data?.length) {
                                this.suggestion = data[0];
                                this.showSuggestion = true;
                            }
                        })
                    }
                } else {
                    this.showSuggestion = false;
                    this.suggestion = {};
                }
            },
            selectionType: function(value, oldValue) {
                Object.assign(this.$data, {...this.$options.data.apply(this), selectionType: value, pincodeList: value === 'CUSTOM' ? this.pincodes : this.pincodesExcept});
                if(value !== oldValue) {
                    this.$emit('pincodeData', value);
                }
            }
        }
    }
</script>

<template>
    <div style="display: flex">
        <div style="display: flex; margin-right: 58px" v-for="selection in selections" :key="selection.type">
            <input name="selectionType" type="radio" :value="selection.type" v-model="selectionType" />
            <span class="text"> {{selection.label}} </span>
        </div>
    </div>
    <div v-if="selectionType != 'ALL'" class="table">
        <div class="tabs">
            <div v-bind:class="{'activeClass': !showUploadComponent}" @click="onListClick" class="row">Enter list</div>
            <div v-bind:class="{'activeClass': showUploadComponent}" @click="onUploadClick" class="row">Upload</div>
        </div>
        <div v-if="!showUploadComponent">
            <div class="pincodeSearch">
                <div class="search">
                    <input class="searchClass" type="text" :maxlength="6" v-model="pincodeInput" @input="cleanVariable" v-bind:placeholder="`Enter pincode`">
                    <div class="searchBtn" @click="onSuggestionClick">
                        {{selectionType == 'CUSTOM' ? 'Add' : 'Remove'}}
                    </div>
                </div>
                <div class="suggestion" v-if="showSuggestion" @click="onSuggestionClick">
                    <div style="font-size: 14px"> {{suggestion.pincode}} </div>
                    <div style="font-size: 14px"> {{`${suggestion.district}, ${suggestion.state}`}} </div>
                </div>
            </div>
            <div class="pincodeRow" style="background-color: #F8F8F8;" v-if="selectionType == 'EXCEPT'">
                <div style="font-size: 14px;"> All the pincodes in India except the following</div>
            </div>
            <div style="max-height: 300px; overflow: scroll">
                <div class="pincodeRow" :key="item.pincode" v-for="item in pincodeList">
                    <div style="font-size: 12px; width: 150px"> {{item.pincode}} </div>
                    <div style="font-size: 12px; width: 250px"> {{`${item.district}, ${item.state}`}} </div>
                    <div style="font-size: 12px; color: #BF0B0B; cursor: pointer;" @click="onRemoveClick(item)"> Remove </div>
                </div>
            </div>
        </div>
        <div v-else>
            <UploadCsv @pincodeList="getPincodeList" :uploadCsvType="'pincodes'" />
        </div>
    </div>
</template>

<style scoped>
    .text {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-left: 4px;
    }
    .table{
        border: 1px solid #E0E0E0;
        border-radius: 12px;
        width: 530px;
        margin-top: 16px;
    }
    .tabs{
        display: flex;
        border-bottom: 1px solid #E0E0E0;
        border-radius: 12px;
        padding: 14px 0 0 22px;
        background: #F8F8F8;

    }
    .pincodeSearch{
        padding: 18px 25px 14px 34px;
        background: #F8F8F8;
        position: relative;
    }
    .row{
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        margin-right: 38px;
        cursor: pointer;
        padding-bottom: 8px;
    }
    .activeClass{
        border-bottom: 3px solid #2E31BE;
    }
    .searchClass{
        background: #FFFFFF;
        border: 1px solid #E4E5E6;
        border-radius: 4px;
        width: 305px;
        padding: 12px 16px;

    }
    .search{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .searchBtn{
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #FFFFFF;
        background: #2E31BE;
        border-radius: 4px;
        padding: 8px 22px;
        cursor: pointer;
    }
    .pincodeRow {
        display: flex;
        padding-left: 40px;
        align-items: center;
        height: 30px;
    }
    .pincodeRow:nth-child(even) {
        background-color: #F8F8F8;
    }
    .suggestion {
        display: flex;
        justify-content: space-between;
        z-index: 2;
        width: 304px;
        border: 1px solid #E4E5E6;
        border-radius: 4px;
        padding: 7px 16px;
        position: absolute;
        background: #fff;
        cursor: pointer;
    }
</style>